module.exports = __webpack_public_path__ + "static/media/regal_ohne_flasche.74f17669.jpg";